// extracted by mini-css-extract-plugin
export default {"container":"AppLayout_container__52+cA","sideNav":"AppLayout_sideNav__QAx-1","bodyMain":"AppLayout_bodyMain__dpGHo"};